import React from 'react';
import { useTranslation } from 'react-i18next';
import {DAYS_MODEL} from "../Apis/functions";
import {Box} from "@mui/material";
import {colors} from '../enums/colors';
import {CustomStyleDayPreview} from "./Styles";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const CustomDayPreview = ({ id="cb_cdp_day_preview", dayArray}) => {
    const { t } = useTranslation();

    return (
        <div className={'main_content days_card no-width minw-200px'}   >
            <Box className={`d-flex justify-content-between day-selector-checkbox readonly`}>
                {DAYS_MODEL.map(({ value, label }) => {
                    const isChecked = dayArray?.includes(value);
                    const inputId = `${id}_${value}`;
                    return (
                        <Box sx={CustomStyleDayPreview({
                            border: colors.shades400,
                            checked: colors.general950,
                            background: isChecked ? colors.general950: colors.general00,
                            text: isChecked ? colors.general00: colors.shades400
                        })}>
                            <Box className={`checkbox-container`}>
                                <article className={`position-relative`}>
                                    <span className={`ibl-font-w-600 fs-12px position-absolute t-50-l-50`}>{t(label)}</span>
                                    <input type='checkbox' value={value} checked={isChecked} id={inputId} disabled={true}/>
                                </article>
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </div>
    );
};

export default CustomDayPreview;
